import { FC } from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Control, Controller } from "react-hook-form";

export interface OpcaoSelect {
  valor: string | number;
  label: string;
}

interface CustomSelectProps {
  name: string;
  control: Control<any>;
  label: string;
  opcoes: OpcaoSelect[];
  disabled?: boolean;
  required?: boolean;
  mostrarSelecione?: boolean;
}

// Select padrão dos formulários para opções fixas (mesmo padrão do XC WMS)
const CustomSelect: FC<CustomSelectProps> = ({
  name,
  control,
  label,
  opcoes,
  disabled = false,
  required = false,
  mostrarSelecione = true,
}) => {
  const labelId = `${name}-label`;

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: required ? `${label} é obrigatório` : false }}
      render={({ field, fieldState }) => (
        <FormControl
          fullWidth
          size="small"
          error={!!fieldState.error}
          disabled={disabled}
        >
          <InputLabel id={labelId} shrink>
            {label}
          </InputLabel>
          <Select
            {...field}
            value={field.value ?? ""}
            labelId={labelId}
            label={label}
            notched
            displayEmpty
          >
            {mostrarSelecione && (
              <MenuItem value="">
                <em>Selecione</em>
              </MenuItem>
            )}
            {opcoes.map((opcao) => (
              <MenuItem key={opcao.valor} value={opcao.valor}>
                {opcao.label}
              </MenuItem>
            ))}
          </Select>
          {fieldState.error && (
            <FormHelperText>{fieldState.error.message}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
};

export default CustomSelect;
